<template>
  <div class="loginSession background">
    <div class="imageDiv">
      <img class="logoImg" src="~common/image/qy_logo.png">
    </div>
    <div class="logoTitle">旗鱼算账宝</div>
    <div class="logoLine">
      <hr>
      <span>登录</span>
      <hr>
    </div>
    <form class="loginForm" action="">
      <div class="loginUserName">
        <div class="userNameIcon">
          <img src="~common/image/user.png">
        </div>
        <input class="userName" type="text" placeholder="请输入登录用户名" v-model="mobile">
        <div class="errorIcon" v-show="mobile !==''"  @click.prevent="deleteFn(1)">
            <img src="~common/image/errorDelete.png">
        </div>
      </div>
      <div class="phontTip">
        <!-- <p>注：请填写商家负责人手机号，或有权限登入算账宝的手机号码</p> -->
      </div>
      <div class="loginPassWord" v-show="true">
        <div class="passWordIcon">
          <img src="~common/image/password.png">
        </div>
        <input class="passWord" type="text" v-model="smsCode" placeholder="请输入密码">
       <div class="errorIcon" v-show="smsCode !==''"  @click.prevent="deleteFn(2)">
          <img src="~common/image/errorDelete.png">
        </div>
      </div>
     <div class="loginHint">
         <div class="loginError" v-show="errorMsgDIv"><img src="~common/image/warning.png"><span>{{errorMsg}}</span></div>  
      </div>
      <div class="loginBtn">
        <button class="login" @click.prevent="getLoginDate" :disabled="ifDisable" :class="{'login':!ifDisable,'noLogin':ifDisable}">登录</button>
      </div>
    </form>
    <div class="loginStyle">
      <div class="selectArea" @click="loginSelect">
        <span>手机动态码登录</span>
      </div> 
    </div>
  </div>
</template>
<script>
  import 'common/js/rem'
  import Common from 'common/js/common'
  import md5 from 'js-md5'
  export default {
    data() {
      return {
        show: true,
        count: '',
        errorMsg: '',
        errorMsgDIv: false,
        mobile: '',
        smsCode: '',
        telError: false,
        ifDisable: true,
        timer: null
      }
    },
    methods: {
      getLoginDate() {
        // this.$router.push({ path: '/shopSelect' })
        const _this = this
        this.$http.get(Common.url_user + '/managerH5LoginByUserName', {
          params: {
            userName: this.mobile,
            passWord: md5(this.smsCode),
            openId: Common.localGet('openId')
          }
        })
        .then(function(response) {
          console.log(JSON.stringify(response))
          if (response.data.code === 0) {
            _this.common.localSet('loginInfo', response.data.data)
            _this.$router.push({ path: '/dataDisplay' })
          } else {
            _this.errorMsgDIv = true
            _this.errorMsg = response.data.msg
          }
        })
        .catch(function(error) {
          // _this.$toast.log('错误的请求' + error)
          _this.$toast(error)
        })
      },
      deleteFn(deleteStyle) {
        if (deleteStyle === 1) {
          this.mobile = ''
        } else if (deleteStyle === 2) {
          this.smsCode = ''
        }
        this.errorMsgDIv = false
      },
      loginSelect() {
        this.$router.push({ path: '/login' })
      }
    },
    watch: {
      mobile(val, oldVal) { // 新值和旧值
        if (val !== oldVal) {
          this.errorMsgDIv = false
        }
        if (this.mobile !== '' && this.smsCode !== '') { // 有一个为空，登录置灰
          this.ifDisable = false
        } else {
          this.ifDisable = true
        }
      },
      smsCode(val, oldVal) { // 新值和旧值
        if (val !== oldVal) {
          this.errorMsgDIv = false
        }
        if (this.mobile !== '' && this.smsCode !== '') { // 有一个为空，登录置灰
          this.ifDisable = false
        } else {
          this.ifDisable = true
        }
      }
    }
  }
</script>


<style scoped>

  .loginSession {
    width: 100%;
    height: 100%;
    background:url('~common/image/loginBackground.jpg') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    text-align: center;
    overflow: auto;
  }
  
  .imageDiv {
    padding-top: 0.54rem;
    text-align: center;
    font-size: 0;
  }
  
  .logoImg {
    width: 1.5rem;
    height: 1.5rem;
  }
  
  .loginForm{
     margin: 0 auto;
     width: 6rem;
     height: auto; 
  }
  .loginUserName,
  .loginPassWord {
    position: relative;
  }
  .loginStyle{
    margin-top: 0.9rem;
    color: #ffffff;
    font-size: 0.28rem;
  }
  .logoLine{
    width: 6rem;
    margin: 0.9rem auto 0 auto;
    font-size: 0.32rem;
    color: #ffffff;
    display:flex;
    display: -webkit-flex; 
    align-items:center;
    justify-content: center;
  }
  .logoLine hr{
    display: inline-block;
    width: 2.4rem;
    height: 1px;
    border: none;
    border-top: 1px solid #ffffff;
  }
  .logoLine span{
    width: 1.2rem;
  }
  .phontTip{
    font-size: 0.24rem;
    /* height: 0.8rem; */
    line-height: 0.4rem;
    color: #ffffff;
    padding: 0 0.1rem;
    margin: 0 0 0.3rem 0;
    text-align: left;
  }
  .marginStyle{
    margin: 0.8rem 0 0.2rem 0!important;
  }
  .selectArea{
    display: inline-block;
    width: 2.6rem;
    height: 0.8rem;
  }
  .selectArea span{
    display: inline-block;
    border-bottom: 1px solid #ffd200;
    color:#ffd200;
  } 
  .userNameIcon,
  .passWordIcon {
    position: absolute;
    left: 0.3rem;
    top: 0.22rem;
  }
  
  .userNameIcon img,
  .passWordIcon img {
    width: 0.42rem;
    height: 0.42rem;
    font-size: 0;
  }
  
  .logoTitle {
    margin-top: 0.26rem;
    font-size: 0.42rem;
    color: #ffffff;
    font-weight: bold;
  } 
  .loginHint {
    height: 0.24rem;
    font-size: 0.24rem;
    color: #ffffff;
    text-align: center;
    margin: 1.8rem 0 0.2rem 0;
  }
  
  .loginUserName {
    margin-top: 0.6rem;
  }
  
  input:focus,button{
    outline: none;
  }
  .userName,
  .passWord {
    width: 6rem;
    height: 0.9rem;
    font-size: 0.28rem;
    color: #000;
    background-color: #F1F2F3;
    border: 1px solid #F74d47;
    padding-left: 1.1rem;
    padding-right: .1rem;
    border-radius: 0.1rem;
    box-sizing: border-box;
  }
  
  /* .passWord {
    width: 3.5rem;
  } */
  
  .verifiCode,.getCode {
    width: 2.4rem;
    height: 0.9rem;
    color: #f74d47;
    font-size: .2rem;
    background-color: #ffffff;
    border-radius: .1rem;
    border: 0;
    vertical-align: top
  }
  .afterCode{
    background-color: #ccc;
  }
  .loginCon{
    margin-top: 1.7rem;
    position: relative;
  }
  .errorIcon{
    position: absolute;
    height: 0.9rem;
    width: 0.6rem;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .errorIcon img{
    width: 0.2rem;
    height: 0.2rem;
    font-size: 0;
  }
  .loginError,.userError,.passwordError {
    /* position: absolute; */
    text-align: center;
    font-size: 0.25rem;
    width: 100%;
    color: #ffffff;
    bottom: 0.3rem;
  }
  .loginError{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  
  .loginError img,.userError img,.passwordError img {
    height: .26rem;
    vertical-align: middle;
    padding-right: .06rem;
  }
  .login {
    width: 6rem;
    height: 0.9rem;
    color: #f74d47;
    font-size: 0.36rem;
    background-color: #ffffff;
    border: 0;
    border-radius: .1rem;
  }
  .noLogin {
    background-color: #CCCCCC;
     color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/loginTwo.vue